"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../../../../material/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _dropdownitemcontrols_styles = _interopRequireDefault(require("./dropdownitemcontrols_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material

/* ========== ~~~~~~~~~~ DROPDOWN ITEM CONTROLS : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary


var _default = (0, _reactJss.default)(_dropdownitemcontrols_styles.default)(function (props) {
  var onEdit = props.onEdit,
      onSave = props.onSave,
      onCancel = props.onCancel,
      onDelete = props.onDelete,
      editMode = props.editMode;
  return _react.default.createElement("span", {
    className: "dropdownitemcontrols ".concat(props.classes.dropdownitemcontrols)
  }, editMode && _react.default.createElement("span", {
    className: "itemcontrol",
    onClick: onSave
  }, _react.default.createElement(_index.Icon, {
    name: "save"
  })), editMode && _react.default.createElement("span", {
    className: "itemcontrol",
    onClick: onCancel
  }, _react.default.createElement(_index.Icon, {
    name: "undo-alt"
  })), !editMode && _react.default.createElement("span", {
    className: "itemcontrol",
    onClick: onEdit
  }, _react.default.createElement(_index.Icon, {
    name: "pencil-alt"
  })), _react.default.createElement("span", {
    className: "itemcontrol",
    onClick: onDelete
  }, _react.default.createElement(_index.Icon, {
    name: "trash-alt"
  })));
});

exports.default = _default;